(function () {
  function getPopup() {
    // Always resolve the freshest copy of the popup. If the theme's
    // variant-picker re-renders its section after load, it can re-insert
    // a fresh, nested copy of this markup — grab the most recent one and
    // remove any stale duplicates so we never end up with two elements
    // sharing the same ids.
    var all = document.querySelectorAll('[data-size-guide-popup]');
    if (!all.length) return null;
    var popup = all[all.length - 1];
    for (var i = 0; i < all.length - 1; i++) {
      all[i].parentNode.removeChild(all[i]);
    }
    if (popup.parentElement !== document.body) {
      document.body.appendChild(popup);
    }
    return popup;
  }

  var wiredPopup = null; // the popup node the widget is currently wired to

  function initSizeGuide(popup) {
    var root = popup.querySelector('#popSizeGuideSimple');
    if (!root) return;
    if (wiredPopup === popup) return; // already wired for this exact node
    wiredPopup = popup;

    var SIZES = [
      { w:8,  h:10, unit:'in' },
      { w:11, h:14, unit:'in' },
      { w:12, h:16, unit:'in' },
      { w:12, h:18, unit:'in' },
      { w:16, h:20, unit:'in' },
      { w:18, h:24, unit:'in' },
      { w:24, h:36, unit:'in' },
      { w:21, h:30, unit:'cm' },
      { w:30, h:40, unit:'cm' },
      { w:50, h:70, unit:'cm' }
    ];
    SIZES.forEach(function(s, i){ s.id = i; });

    var SOFA_IN = 82;
    var SOFA_ASPECT = 349.24 / 683.97;
    var HANG_GAP_IN = 8;

    var listEl = root.querySelector('#psgList');
    var zoneEl = root.querySelector('#psgFrameZone');
    var sofaSvg = root.querySelector('#psgSofaSvg');
    var sofaLabelEl = root.querySelector('#psgSofaLabel');
    var orientBtns = root.querySelectorAll('.psg-unit[data-orient]');

    var state = { orient: 'portrait', id: 5 };

    function fmt(n){ return (Math.round(n * 10) / 10).toString().replace(/\.0$/, ''); }
    function toInches(entry){ return entry.unit === 'cm' ? entry.w / 2.54 : entry.w; }
    function heightInches(entry){ return entry.unit === 'cm' ? entry.h / 2.54 : entry.h; }

    function dims(entry){
      var w = state.orient === 'landscape' ? entry.h : entry.w;
      var h = state.orient === 'landscape' ? entry.w : entry.h;
      return { w:w, h:h };
    }
    function displayText(entry){
      var d = dims(entry);
      return fmt(d.w) + '×' + fmt(d.h) + (entry.unit === 'in' ? '″' : ' cm');
    }

    function ppi(){
      var w = window.innerWidth;
      var maxPx = w < 480 ? 190 : (w < 800 ? 230 : 270);
      var tallestIn = Math.max.apply(null, SIZES.map(function(s){
        return Math.max(toInches(s), heightInches(s));
      }).concat([36]));
      var maxInches = tallestIn + HANG_GAP_IN + (SOFA_IN * SOFA_ASPECT);
      return maxPx / maxInches;
    }

    function buildList(){
      listEl.innerHTML = '';
      SIZES.forEach(function(entry){
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'psg-item' + (entry.id === state.id ? ' active' : '');
        btn.setAttribute('role', 'option');
        btn.setAttribute('aria-selected', entry.id === state.id ? 'true' : 'false');
        btn.textContent = fmt(entry.w) + '×' + fmt(entry.h) + (entry.unit === 'in' ? '″' : ' cm');

        btn.addEventListener('click', function(){
          if (entry.id === state.id) return;
          state.id = entry.id;
          listEl.querySelectorAll('.psg-item').forEach(function(b){
            var match = b === btn;
            b.classList.toggle('active', match);
            b.setAttribute('aria-selected', match ? 'true' : 'false');
          });
          renderFrame(true);
        });

        listEl.appendChild(btn);
      });
    }

    function renderFrame(animate){
      var entry = SIZES[state.id];
      var scale = ppi();

      var label = document.createElement('div');
      label.className = 'psg-frame-label';
      label.textContent = displayText(entry);

      var wIn = (state.orient === 'landscape' ? heightInches(entry) : toInches(entry));
      var hIn = (state.orient === 'landscape' ? toInches(entry) : heightInches(entry));

      var frame = document.createElement('div');
      frame.className = 'psg-frame';
      frame.style.width = Math.round(wIn * scale) + 'px';
      frame.style.height = Math.round(hIn * scale) + 'px';

      zoneEl.innerHTML = '';
      zoneEl.appendChild(label);
      zoneEl.appendChild(frame);

      requestAnimationFrame(function(){
        frame.classList.add('in');
        label.classList.add('in');
      });

      var sofaPx = Math.round(SOFA_IN * scale);
      sofaSvg.style.width = sofaPx + 'px';
      sofaLabelEl.textContent = SOFA_IN + '″ sofa';
    }

    orientBtns.forEach(function(btn){
      btn.addEventListener('click', function(){
        if (btn.classList.contains('active')) return;
        orientBtns.forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        state.orient = btn.getAttribute('data-orient');
        renderFrame(true);
      });
    });

    window.addEventListener('resize', function(){ renderFrame(false); });

    buildList();
    renderFrame(true);
  }

  function openPopup() {
    var popup = getPopup();
    if (!popup) return;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    initSizeGuide(popup);
  }

  function closePopup() {
    var popup = document.querySelector('[data-size-guide-popup]');
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Event delegation on document — works even if the theme replaces the
  // trigger or close buttons with new elements after this script first runs.
  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-size-guide-open]');
    if (openTrigger) {
      event.preventDefault();
      openPopup();
      return;
    }
    var closeTrigger = event.target.closest('[data-size-guide-close]');
    if (closeTrigger) {
      closePopup();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var popup = document.querySelector('[data-size-guide-popup]');
    if (popup && popup.classList.contains('is-open')) closePopup();
  });
})();